import { getConfig } from './config';

async function get(params) {
  const { appsScriptUrl } = getConfig();
  const url = `${appsScriptUrl}?${new URLSearchParams(params)}`;
  const res  = await fetch(url);
  return res.json();
}

async function getWithPayload(action, payload) {
  const { appsScriptUrl, secretToken } = getConfig();
  const url = `${appsScriptUrl}?action=${action}&token=${secretToken}&payload=${encodeURIComponent(JSON.stringify(payload))}`;
  const res  = await fetch(url);
  return res.json();
}

export async function fetchData() {
  const data = await get({ action: 'getData' });
  if (data.status !== 'success') throw new Error(data.message || 'Fetch failed');
  return data;
}

export const writeTransactions = (transactions) => getWithPayload('writeTransactions', transactions);
export const writeCorrection   = (rule)          => getWithPayload('writeCorrection', rule);
export const writeBudget       = (budget)         => getWithPayload('writeBudget', budget);
export const writeCommitted    = (item)           => getWithPayload('writeCommitted', item);
export const writeManualTx     = (tx)             => getWithPayload('writeTransactions', [tx]);